import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerAutocomplete = styled.div``
export const Text = styled.span`
  color: ${colors.blue};
`
